import React, { Component, Fragment } from "react";
import { ExcelRenderer } from "react-excel-renderer";
import { connect } from "react-redux";
import BacktestService from "../../../service/backtest.service";
import Spinner from "../../common/spinner";
import data from "./filterData.json";
// import UniverseAnalyze from "./Universe.Analyze";
// import {} from 'font-awesome'
import TunersAndInputHolder from "./Theme_base/Tuners_and_input/TunersAndInputHolder";
import TreeTableHolder from "./TreeTableHolder";
import "./Universe.css";
import "./Universe.scss";
import ButtonGroup from "./universe/buttonGroup";
import universeHelper from "./universe/universeHelper";
import UniverseLite from "./UniverseLite";
import Pannel from "../Create/universe_lite/Analyze/pannel";

class Universe extends Component {
  constructor(props) {
    super(props);
    this.btnGroup = React.createRef(); // Create a ref object
    //   this.forceUpdateHandler = this.forceUpdateHandler.bind(this);
  }
  state = {
    selectedItems: [],
    items: [
      {
        id: 1,
        security: "1 Dow Jones Global Titans (DJGT)",
        type: "Index",
        country: "Global",
        last_price: "380",
        limit: "10%",
      },
      {
        id: 2,
        security: "1 Dow Jones Global Titans (DJGT)",
        type: "Index",
        country: "Global",
        last_price: "380",
        limit: "10%",
      },
      {
        id: 3,
        security: "1 Dow Jones Global Titans (DJGT)",
        type: "Index",
        country: "Global",
        last_price: "380",
        limit: "10%",
      },
    ],
    selectionListDefaultData: data,
    visible: false,
    filterSelectedItems: {},
    originalScenarioList: [],
    filteredScenarioList: this.props.symbols,
    spinner: false,
    filterResponseList: [],
    filteredTableData: [],
    FilterError: false,
    error: false,
    cloneTableInitialData: [],
    inValidXlData: false,
    DisplayReset: false,
    tech: 0,
    esg: 0,
    filter: {},
    showAddRowModel: false,
    portfolioTableActive: true,
  };

  select = (e) => {
    const { selectedItems } = this.state;
    const { value } = e.target;
    if (selectedItems.indexOf(value) > -1) {
      selectedItems.splice(selectedItems.indexOf(value), 1);
    } else {
      selectedItems.push(value);
    }
    this.setState({ selectedItems });
  };

  toggleFilter = () => {
    this.setState({
      visible: !this.state.visible,
    });
    // resetting step 3 slider data
    // const { reSetRiskActiveData, activePortfolioID, cloneModelportfolios,resetActivedata} = this.props;
    // var activeData = cloneModelportfolios.filter(e => e.scenario_id == activePortfolioID)
    // resetActivedata(activeData);
    // this.renderTab0(cloneModelportfolios);
    // reSetRiskActiveData(activeData);
    // alert("reset");
  };

  // forceUpdateHandler() {
  //   const { SecurityAddedManually } = this.props;
  //   if (SecurityAddedManually.length > 0)
  //   this.forceUpdate();
  // }

  filterSelected = (e, callback) => {
    e.preventDefault();

    let formdata = this.state.selectionListDefaultData;
    // this.state.filterSelectedItems
    if (formdata.Technical[e.target.name]) {
      if (!(e.target.name in this.state.filterSelectedItems)) {
        this.setState({
          tech: this.state.tech + 1,
        });
      } else if (
        // e.currentTarget.selectedIndex == 0 &&
        // e.currentTarget.selectedIndex.text === "All"
        e.currentTarget.options[e.currentTarget.selectedIndex].text === "All" &&
        !(
          this.state.filterSelectedItems &&
          Object.keys(this.state.filterSelectedItems).length === 0 &&
          this.state.filterSelectedItems.constructor === Object
        )
      ) {
        this.setState({
          tech: this.state.tech - 1,
        });
      }
    } else if (formdata.ESG[e.target.name]) {
      if (!(e.target.name in this.state.filterSelectedItems)) {
        this.setState({
          esg: this.state.esg + 1,
        });
      } else if (
        // e.currentTarget.selectedIndex == 0
        e.currentTarget.options[e.currentTarget.selectedIndex].text === "All" &&
        !(
          this.state.filterSelectedItems &&
          Object.keys(this.state.filterSelectedItems).length === 0 &&
          this.state.filterSelectedItems.constructor === Object
        )
      ) {
        this.setState({
          esg: this.state.esg - 1,
        });
      }
    }

    const {
      optimization_params,
      activePortfolioID,
      setSecuritiesValidToNextStep,
      setSymbols,
    } = this.props;

    const { cloneTableInitialData } = this.props;
    if (e.currentTarget.selectedIndex == 0) {
      e.currentTarget.style.backgroundColor = "#f8f8f8";
    } else e.currentTarget.style.backgroundColor = "#add8e6";

    var selectOptionName = e.target.name;

    var gt = e.target[e.target.selectedIndex].getAttribute("gt");
    var lt = e.target[e.target.selectedIndex].getAttribute("lt");

    let y = {};
    if (gt) y["gt"] = gt;
    if (lt) y["lt"] = lt;

    let x = this.state.filterSelectedItems;

    if (e.currentTarget.selectedIndex == 0) {
      delete x[selectOptionName];
    } else {
      x[selectOptionName] = y;
    }

    for (let i in x) {
      if (Object.keys(x[i]).length == 0) {
        delete x[i];
      }
    }

    let arr = [];
    for (let i in cloneTableInitialData) {
      arr.push(cloneTableInitialData[i]["symbol"]);
    }
    this.setState({
      filterSelectedItems: x,
      spinner: true,
      // originalScenarioList:arr
    });

    let _user = window.localStorage.getItem("_user");

    if (_user) {
      _user = JSON.parse(_user);
    }
    var xmlHttp = new XMLHttpRequest();

    xmlHttp.onreadystatechange = () => {
      if (xmlHttp.readyState === 4) {
        if (xmlHttp.status === 200) {
          // callback(xmlHttp.responseText);

          let response = JSON.parse(xmlHttp.responseText);

          if (Object.keys(response["symbol"]).length) {
            let filteredSymbols = response["symbol"];
            // let compareFilteredData = originalScenarioList.filter(function(d) {
            //   return Object.values(filteredSymbols).indexOf(d["symbol"]) !== -1;
            // });
            let compareFilteredData = cloneTableInitialData.filter(function (
              d
            ) {
              return Object.values(filteredSymbols).indexOf(d["symbol"]) !== -1;
            });
            this.setState(
              {
                filteredScenarioList: compareFilteredData,
                filterResponseList: response,
                spinner: false,
                error: false,
                FilterError: false,
              },
              () => {
                setSymbols(compareFilteredData);
                // block next step if not meets criteria
                let upper_bounds =
                  optimization_params[activePortfolioID].upper_bounds;
                setSecuritiesValidToNextStep(
                  universeHelper.securityValidate(
                    upper_bounds,
                    compareFilteredData.length
                  )
                );
              }
            );
          } else if (Object.keys(response["symbol"]).length === 0) {
            // console.log("there is no data for seleted options");
            let response = JSON.parse(xmlHttp.responseText);
            let empty = [];
            this.setState(
              {
                FilterError: true,
                error: false,
                spinner: false,
                filteredScenarioList: {},
                filterResponseList: response,
              },
              () => {
                setSymbols(empty);
                setSecuritiesValidToNextStep(true);
              }
            );
          }
        } else {
          this.setState({
            FilterError: false,
            error: true,
            spinner: false,
          });
        }
      }
    };

    xmlHttp.open(
      "post",
      "https://api.iqcioadvisers.com/ajax_filter_securities/"
    );
    xmlHttp.setRequestHeader("Content-type", "application/json");
    xmlHttp.setRequestHeader("Authorization", "Bearer " + _user.token);
    let callDetails = {};
    callDetails["symbols"] = arr; //This shall be comma separated list of original securities
    callDetails["filters"] = x;
    // callDetails["symbols"] = this.state.filteredScenarioList;
    xmlHttp.send(JSON.stringify(callDetails));
  };

  resetFilter = () => {
    const {
      setSymbols,
      setSecuritiesValidToNextStep,
      cloneTableInitialData,
      // active,
      // reSetBackendParamStyle,
    } = this.props;
    // const { originalScenarioList } = this.state;
    var elements = document.getElementsByClassName("selectW");
    for (var i = 0; i < elements.length; i++) {
      elements[i].style.backgroundColor = "";
      elements[i].selectedIndex = 0;
    }
    // setSymbols(originalScenarioList);
    setSymbols(cloneTableInitialData);
    setSecuritiesValidToNextStep(true);
    this.setState({
      filterSelectedItems: {},
      filteredScenarioList: {},
      FilterError: false,
      error: false,
      tech: 0,
      esg: 0,
    });

    // reSetBackendParamStyle(active.data[0]["styles"]);
    return true;
  };

  list = (type) => {
    let formdata = this.state.selectionListDefaultData;
    const selection = [];
    for (let i in formdata[type]) {
      var temp1 = [];
      for (var j in formdata[type][i]) {
        temp1.push(
          <option
            name={j}
            key={j}
            gt={formdata[type][i][j]["gt"]}
            lt={formdata[type][i][j]["lt"]}
          >
            {formdata[type][i][j]["display"]}
          </option>
        );
      }

      selection.push(
        <select
          name={i}
          key={i}
          onChange={this.filterSelected}
          className="selectW"
          displaylabel={temp1[0].key}
        >
          {temp1}
        </select>
      );
    }
    return selection;
  };

  // file upload handler

  xlsxEvent = (event) => {
    const {
      setSymbols,
      setSecuritiesValidToNextStep,
      activePortfolioID,
      optimization_params,
    } = this.props;
    var file = event.target.files[0];

    if (file) {
      //reseting filter
      // this.resetFilter();
      ExcelRenderer(file, (err, res) => {
        if (err) {
          console.log("Error");
        } else {
          let response = res["rows"];
          // checks if any null or empty data and removes it
          var filtered = response.map((d) => {
            return d.filter((el) => el != null);
          });

          var filteredData = filtered.filter((d) => d.length);

          this.setState({ DisplayReset: true });
          var heading = filteredData[0];
          if (
            heading.length > 0 &&
            heading[0].toLowerCase() === "security" &&
            heading[1].toLowerCase() === "symbol" &&
            heading[2].toLowerCase() === "classification" &&
            heading[3].toLowerCase() === "asset class" &&
            heading[4].toLowerCase() === "style"
          ) {
            var data = filteredData.slice(1, response.length);
            var arr = [];
            for (let i = 0; i < data.length; i++) {
              let obj = {};
              obj.fund_name = data[i][0];
              obj.symbol = data[i][1];
              obj.new_classification = data[i][2];
              obj.fund_asset_class_focus = data[i][3];
              obj.new_style = data[i][4];
              obj.val = data[i][5] ? data[i][5] : null;
              arr.push(obj);
            }
            this.setState({ originalScenarioList: arr, inValidXlData: false });
            let filteredArr = arr.filter((d) => Object.keys(d).length !== 0);

            setSymbols(filteredArr);

            // block next step if not meets criteria
            let upper_bounds =
              optimization_params[activePortfolioID].upper_bounds;
            setSecuritiesValidToNextStep(
              universeHelper.securityValidate(upper_bounds, filteredArr.length)
            );
          } else {
            this.setState({ inValidXlData: true });
          }
        }
      });
    }
  };
  // file reset handler
  resetTableData = (e) => {
    this.resetFilter();
    let {
      setSymbols,
      cloneTableInitialData,
      setSecuritiesValidToNextStep,
      // reSetBackendParamStyle,
    } = this.props;
    // let cloneData = this.props.cloneTableInitialData;
    // console.log(cloneData,"cloned data redux")
    if (cloneTableInitialData) {
      this.setState({
        originalScenarioList: cloneTableInitialData,
        inValidXlData: false,
        DisplayReset: false,
      });
      setSymbols(cloneTableInitialData);
      document.getElementById("upload_scenario_file").value = "";
      setSecuritiesValidToNextStep(true);
    }
  };

  // how many more portfolio
  requiredPortfolio = (max_limit, portfolioLength) => {
    let x = max_limit * portfolioLength;
    let y = 100 - x;
    let z = y / max_limit;
    return Math.ceil(z);
  };

  componentWillMount() {
    // resetting error or missing items to zeros for limit step sliders
    // this.checkIndividualSecurityStyle();
    // this.checkIndividualSecurityClass();
    // this.checkOverallFocus();
    const {
      symbols,
      setSymbols,
      activePortfolioID,
      setInitialTableData,
      portfolioActive,
    } = this.props;
    if (activePortfolioID !== 0 && portfolioActive === false) {
      if (symbols && symbols.length === 0) {
        BacktestService.getScenarioShortlist(activePortfolioID, "CI").then(
          (data) => {
            setSymbols(data);

            this.setState({
              // originalScenarioList: data
              filteredScenarioList: data,
            });
            setInitialTableData(data);
          }
        );
      }
    }
  }
  componentDidMount = () => {
    // const {
    //   symbols,
    //   setSymbols,
    //   activePortfolioID,
    //   setInitialTableData,
    //   portfolioActive,
    //   reSetBackendParamStyle,
    //   styles,
    //   active,
    // } = this.props;
    // if (activePortfolioID !== 0 && portfolioActive === false) {
    //   if (symbols && symbols.length == 0) {
    //     BacktestService.getScenarioShortlist(activePortfolioID).then((data) => {
    //       setSymbols(data);

    //       this.setState({
    //         // originalScenarioList: data
    //         filteredScenarioList: data,
    //       });
    //       setInitialTableData(data);
    //       this.validate_backendparams_limits({ symbols: data, ...this.props });
    //     });
    //   }
    // }

    if (this.props.symbols.length > 0 && !this.props.portfolioActive) {
      setTimeout(() => this.btnGroup.current.scrollIntoView(), 300);
    }
  };

  componentWillReceiveProps(nextProps) {
    console.log("==========universe will receive props========");
    console.log(nextProps);
    console.log("====================");
  }
  Error = (message) => {
    return (
      <li>
        <span className="dataWarning">
          <i
            className="fa fa-exclamation-circle"
            style={{ fontSize: "18px" }}
          ></i>{" "}
          {message}
        </span>
      </li>
    );
  };

  // ========== ** =============

  // ***  error handler for missing/empty security ***
  clone_list = (data, e) => {
    if (data && data.length) {
      return data
        .filter((d) => d[`${e}`] !== "Cash")
        .map((d) => d[`${e}`])
        .sort();
    }
  };
  // styles

  checkIndividualSecurityStyle = () => {
    // check individual value and make it zero before it renders;
    const { styles, reSetBackendParamStyle, symbols } = this.props;
    let cloneStyles = [...styles];
    let list = this.clone_list(styles, "style");
    let errorValueList = [];
    if (list.length) {
      for (let i = 0; i < list.length; i++) {
        var filtered = symbols.filter((d) => d.new_style == list[i]);
        if (filtered.length == 0) {
          errorValueList.push(list[i]);
        }
      }
    }
    if (errorValueList.length) {
      for (let j = 0; j < errorValueList.length; j++) {
        let newData = cloneStyles.filter((e) => e.style == errorValueList[j]);
        newData[0]["max"] = "0";
      }
      reSetBackendParamStyle(cloneStyles);
    }
  };
  // classification
  checkIndividualSecurityClass = () => {
    const { asset_class, reSetBackendParamClass, symbols } = this.props;

    let cloneClass = [...asset_class];

    let list = this.clone_list(asset_class, "name");
    var errorValueList = [];
    if (list.length) {
      for (let a = 0; a < list.length; a++) {
        var filtered = symbols.filter((d) => d.new_classification == list[a]);
        if (filtered.length == 0) {
          errorValueList.push(list[a]);
        }
      }
    }
    if (errorValueList.length) {
      for (let j = 0; j < errorValueList.length; j++) {
        let newData = cloneClass.filter((e) => e.name == errorValueList[j]);
        newData[0]["max"] = "0";
      }
      reSetBackendParamClass(cloneClass);
    }
  };
  // asset class
  checkOverallFocus = () => {
    const { overall_focus, reSetBackendParamOverallFocus, symbols } =
      this.props;

    let cloneFocus = [...overall_focus];
    let list = this.clone_list(overall_focus, "name");
    var errorValueList = [];
    if (list.length) {
      for (let i = 0; i < list.length; i++) {
        var filtered = symbols.filter(
          (d) => d.fund_asset_class_focus == list[i]
        );
        if (filtered.length == 0) {
          errorValueList.push(list[i]);
        }
      }
    }
    if (errorValueList.length) {
      for (let k = 0; k < errorValueList.length; k++) {
        let newData = cloneFocus.filter((e) => e.name == errorValueList[k]);
        newData[0]["max"] = "0";
      }
      reSetBackendParamOverallFocus(cloneFocus);
    }
  };

  //============*Pannelconfig*===============
  addRowHandler = () => {
    this.setState({
      showAddRowModel: !this.state.showAddRowModel,
    });
  };
  addRowToggleHandler = () => {
    this.setState({
      showAddRowModel: !this.state.showAddRowModel,
    });
  };
  callBack = () => {
    this.setState({
      portfolioTableActive: false,
    });
  };

  //============**===============

  render() {
    const { inValidXlData } = this.state;

    const filteredScenarioList = this.props.symbols;
    const cloneTableInitialData = this.props.cloneTableInitialData;
    const {
      symbols,
      activePortfolioID,
      optimization_params,
      securitiesValidToNextStep,
      portfolioActive,
      asset_class,
      overall_focus,
      styles,
      create_portfolio_type,
      addPannel,
    } = this.props;
    const { FilterError, error, DisplayReset, visible } = this.state;

    const max_limit_upperBound =
      optimization_params &&
      Object.keys(optimization_params).length > 0 &&
      activePortfolioID !== 0 &&
      optimization_params[activePortfolioID] &&
      optimization_params[activePortfolioID].upper_bounds
        ? optimization_params[activePortfolioID].upper_bounds
        : 0;

    const element = document.getElementById("btnGroup_universe");
    if (
      filteredScenarioList &&
      filteredScenarioList.length > 0 &&
      element &&
      !portfolioActive
    ) {
      element.scrollIntoView();
    }
    return (
      <div className="universe">
        {!portfolioActive ? (
          <Fragment>
            <div id="btnGroup_universe" ref={this.btnGroup}>
              <ButtonGroup
                upload={this.xlsxEvent}
                DisplayReset={DisplayReset}
                resetHandler={this.resetTableData}
                filterVisible={visible}
                filterHandler={this.toggleFilter}
              />
            </div>

            <div
              className={`${
                visible ? "filter_style fadeIn" : "fadeOut"
              } container`}
              id="universeFilter"
            >
              <form
                name="universal_filter"
                className="universal_filter"
                onReset={this.resetFilter}
                onSubmit={this.submitFilteredData}
                scenario_id={activePortfolioID}
              >
                <input type="hidden" name="scenario_id" value="" />

                <div className="filter">
                  <ul className="nav-tabs nav nav-justified container">
                    <li className="nav-item active container">
                      <a
                        href="#tech"
                        className="nav-link row active"
                        data-toggle="tab"
                      >
                        <h5 className="col-md-10 filterHeading">
                          TECHNICALS &amp; FUNDAMENTALS
                          <i
                            className={`${
                              this.state.tech > 0
                                ? "filterIconColorset1"
                                : "filterIconColorset2"
                            } fa fa-filter col-md-2`}
                          ></i>
                        </h5>
                      </a>
                    </li>
                    <li className="nav-item container">
                      <a href="#env" className="nav-link row" data-toggle="tab">
                        <h5 className="col-md-10 filterHeading">
                          ENVIROMENTAL, SOCIAL AND GOVERNANCE CRITERIA
                          <i
                            className={`${
                              this.state.esg > 0
                                ? "filterIconColorset1"
                                : "filterIconColorset2"
                            } fa fa-filter col-md-2`}
                            // style={{ color: this.state.filterIconColorset }}
                          ></i>
                        </h5>
                      </a>
                    </li>
                  </ul>
                  <div className="tab-content">
                    <div className="tab-pane active" id="tech">
                      {this.list("Technical").map((item, i) => (
                        <div className="filterItem" key={i}>
                          {item.props.displaylabel} : {item}
                        </div>
                      ))}
                    </div>
                    <div className="tab-pane" id="env">
                      {this.list("ESG").map((item, i) => (
                        <div className="filterItem" key={i}>
                          {item.props.displaylabel} : {item}
                        </div>
                      ))}
                      <br />
                    </div>
                  </div>

                  <div className="filterResetbutton">
                    <button type="reset" onClick={this.resetTableData}>
                      <i className="fa fa-refresh" aria-hidden="true"></i>
                      &nbsp; Reset Filters
                    </button>
                  </div>
                </div>

                {this.state.spinner ? (
                  <i className="fa fa-spinner fa-pulse fa-fw" />
                ) : null}
              </form>
            </div>
            <div className="universe__table">
              {inValidXlData ? (
                <div className="universe__table__warning">
                  <span className="dataWarning">
                    Invalid Excel data, please enter properly formatted data.
                  </span>
                </div>
              ) : null}
              {FilterError ? (
                <div className="universe__table__warning">
                  <span className="dataWarning">
                    No Securites match selected filter criteria. Please
                    change/reset filters.
                  </span>
                </div>
              ) : null}
              {error ? (
                <div className="universe__table__warning">
                  <span className="dataWarning">
                    Unable to process request at this time. Please try again
                    later.
                  </span>
                </div>
              ) : null}
              {/* error if allocation value doesnt matches */}
              {!securitiesValidToNextStep ? (
                <div className="universe_note">
                  <span className="dataWarning">
                    {`Please add at least ${this.requiredPortfolio(
                      max_limit_upperBound,
                      symbols.length
                    )} more securities to fulfill the ${max_limit_upperBound}% max allocation limit to proceed to next step.`}
                  </span>
                </div>
              ) : null}

              {filteredScenarioList && filteredScenarioList.length ? (
                <Fragment>
                  <div style={{ display: "flex" }}>
                    <div style={{ padding: "5px 0px" }}>
                      Below is the list of securities based on selected
                      criteria. This list forms the universe of securities for
                      portfolio creation. You can also filter the list using
                      Filter Securities option.
                    </div>
                    <div
                      style={{
                        width: "38%",
                        padding: "5px 0px",
                        textAlign: "right",
                        fontWeight: "bold",
                      }}
                    >
                      SHOWING {filteredScenarioList.length} OF{" "}
                      {cloneTableInitialData.length}
                    </div>
                  </div>
                  {/*}
                   <CustomTreeTable
                    filteredScenarioList={filteredScenarioList}
                    activePortfolioID={activePortfolioID}
                    optimization_params={optimization_params}
                    baseDataLength={cloneTableInitialData.length}
                  /> */}

                  {/* {displayStyleError == true ? (
                    <div className="universe_note">
                      <ul>
                        {this.Error(
                          `Could not find securities for allocating as per the limits/core allocation/max limit, as highlited in red.  Please check the securities list and try again.`
                        )}
                      </ul>
                    </div>
                  ) : null} */}
                  {addPannel ? (
                    <div className="Pannel ">
                      <Pannel
                        showAddRowModel={this.state.showAddRowModel}
                        addRowHandler={this.addRowHandler}
                        addRowToggleHandler={this.addRowToggleHandler}
                        callBack={this.callBack}
                        AddManualSecurityMyUniverse={false}
                        AddManualSecurity={true}
                      />
                    </div>
                  ) : null}
                  {filteredScenarioList.length > 0 && (
                    <TreeTableHolder
                      activePortfolioID={activePortfolioID}
                      getScenarioShortlist={filteredScenarioList}
                      overall_focus={overall_focus}
                      asset_class={asset_class}
                      styles={styles}
                      optimization_params={optimization_params}
                      validate_slider_limits={true}
                    />
                  )}
                  {create_portfolio_type === "THEME_BASED" ? (
                    //  &&
                    // Object.keys(this.props.optimization_params).length > 0
                    <TunersAndInputHolder />
                  ) : null}
                  {/* table to download as xlsx */}
                  {filteredScenarioList && filteredScenarioList.length > 0 ? (
                    <table id="universe_table_download">
                      <thead>
                        <tr>
                          <th>Security</th>
                          <th>Symbol</th>
                          <th>Classification</th>
                          <th>Asset Class</th>
                          <th>Style</th>
                          <th>Core Allocation</th>
                        </tr>
                      </thead>
                      <tbody>
                        {filteredScenarioList.map((item, i) => (
                          <tr key={`key-${i}`}>
                            <td>
                              <label htmlFor={`checkbox-${i}`}>
                                {item.fund_name}
                              </label>
                            </td>
                            <td>
                              <label htmlFor={`checkbox-${i}`}>
                                {item.symbol}
                              </label>
                            </td>
                            <td>
                              <label htmlFor={`checkbox-${i}`}>
                                {item.new_classification}
                              </label>
                            </td>
                            <td>
                              <label htmlFor={`checkbox-${i}`}>
                                {item.fund_asset_class_focus}
                              </label>
                            </td>
                            <td>
                              <label htmlFor={`checkbox-${i}`}>
                                {item.new_style}
                              </label>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  ) : null}
                </Fragment>
              ) : filteredScenarioList &&
                filteredScenarioList.length === 0 &&
                inValidXlData === false &&
                FilterError === false ? (
                <div className="universe__table__spinner-holder">
                  <Spinner />
                </div>
              ) : null}
            </div>
          </Fragment>
        ) : null}
        {portfolioActive ? <UniverseLite /> : null}
      </div>
    );
  }
}

export default connect(
  ({
    create: {
      steps: {
        risk: { activePortfolioID, active },
        universe: {
          symbols,
          cloneTableInitialData,
          securitiesValidToNextStep,
          cloneStyles,
        },
        backendParams: {
          optimization_params,
          styles,
          asset_class,
          fund_type,
          overall_focus,
        },
        universeLite: { portfolio, portfolioActive },
        fundType: { displayStyleError },
      },
      cloneModelportfolios,
      create_portfolio_type,
      modelportfolios,
      addPannel,
    },
  }) => ({
    symbols,
    activePortfolioID,
    cloneTableInitialData,
    cloneStyles,
    optimization_params,
    securitiesValidToNextStep,
    portfolio,
    portfolioActive,
    styles,
    active,
    cloneModelportfolios,
    asset_class,
    fund_type,
    overall_focus,
    displayStyleError,
    create_portfolio_type,
    slected_obj: optimization_params[activePortfolioID],
    modelportfolios,
    addPannel,
  }),
  (dispatch) => ({
    setSymbols: (payload) => dispatch({ type: "SET_UNIVERSE_DATA", payload }),
    setInitialTableData: (payload) =>
      dispatch({ type: "SET_INITIAL_TABLE_DATA", payload }),
    setSecuritiesValidToNextStep: (payload) =>
      dispatch({ type: "SET_UNIVERSE_SECURITYVALIDITY", payload }),
    setPortfolioName: (value) =>
      dispatch({ type: "SET_PORTFOLIO_NAME", payload: value }),
    // reset step-3 slider data
    reSetBackendParamStyle: (value) =>
      dispatch({ type: "SET_BACKENDPARAMS_STYLE_RESET", payload: value }),

    reSetBackendParamClass: (value) =>
      dispatch({ type: "SET_BACKENDPARAMS_CLASS_RESET", payload: value }),

    reSetBackendParamOverallFocus: (value) =>
      dispatch({ type: "SET_BACKTESTPARAMS_OVERALL_FOCUS", payload: value }),
  })
)(Universe);



// WEBPACK FOOTER //
// ./src/components/pages/Create/Universe.jsx